import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import NumberField from '@components/text-field/NumberField';



interface SizeItemProps {
	label: string,
	count: number,
	onClick: (label: string, value: number) => void,
}


const SizeItem = (props: SizeItemProps) => {
	const { label, count, onClick } = props;
	const { t } = useTranslation('forms');

	return (
		<NumberField
			label={label}
			rounded={true}
			value={count === 0 ? undefined : count}
			valueUnits={t('units.piecesUnit')}
			placeholder={t('units.piecesUnit')}
			maxNumber={100}
			onChange={value => value ? onClick(label, value) : onClick(label, 0)} />
	);
}

export default memo(SizeItem);